export const ruTranslations = {
	common: {
		required: 'Обязательное поле',
		continue: 'Продолжить',
		birth_date: 'Дата рождения',
		invalid_email: 'Некорректный email',
		first_name: 'Имя',
		last_name: 'Фамилия',
		email: 'Почта',
		phone_number: 'Номер телефона',
		page_not_found: 'Страница не найдена',
		pay: 'Оплатить',
		payed: 'Оплачено',
		not_payed: 'Не оплачено',
		free: 'Бесплатно',
		open: 'Открыть',
		or: 'или',
		cancel: 'Отменить'
	},
	login: {
		enter: 'Войти',
		welcome_back: 'С возвращением!',
		enter_email: 'Введите почту',
		wrong_email: 'Неправильная почта',
		email_does_not_exist: 'Такой почты не существует',
		dont_have_account: 'Нет аккаунта?',
		sign_up: 'Зарегистрируйтесь',
		sign_in_with: 'Авторизоваться с {{platform}}',
		get_to_know_your_potential: 'Узнайте свой потенциал уже сегодня!',
		pass_test_and_get_results:
			'Пройдите тест и получите персональные результаты на почту! Регистрация занимает всего 10 секунд.'
	},
	register: {
		sign_up: 'Регистрация',
		sign_up_for_test: 'Регистрация на тест',
		already_have_account: 'Уже есть аккаунт?',
		email_already_in_use: 'Эта почта уже используется',
		enter_valid_number: 'Введите валидный номер',
		login: 'Авторизоваться'
	},
	otp: {
		invalid_otp: 'Неверный код, попробуйте ввести заново',
		enter_otp:
			'Введите 6-значный код, отправленный на почту <0>{{email}}</0>',
		resend_available_in:
			'Повторная отправка будет доступна через: {{countdown}}c',
		resending: 'Ваш код отправляется',
		resend: 'Повторно отправить 6-значный код на почту'
	},
	instructions: {
		get_started: 'Приступить',
		sign_up_completed: 'Регистрация прошла <0>успешно</0>',
		proceed_to_test: 'Теперь вы можете пройти тестирование',
		make_sure_have_time:
			'Убедитесь, что у вас есть 15-20 минут свободного времени',
		test_consists_of_100_questions: 'Тест состоит из 100 вопросов',
		try_to_spend_20_seconds:
			'Старайтесь тратить не более 20 секунд на каждый вопрос',
		no_right_or_wrong_answers:
			'Здесь нет правильных или неправильных ответов - просто будьте собой'
	},
	profile: {
		my_reports: 'Мои отчеты',
		settings: 'Настройки профиля',
		logout: 'Выйти',
		hello: 'Личная информация',
		save: 'Сохранить изменения',
		cancel: 'Отменить',
		profile_edit: 'Редактирование профиля',
		update_success: 'Ваши данные сохранены',
		update_error: 'Ваши данные не сохранены',
		test_breakdown: 'Разбор теста'
	},
	result: {
		full_report: 'Получить полный отчет',
		demo_talents: 'Твои топ 5',
		prev_question: 'Предыдущий вопрос',
		note: 'Доверьтесь своей интуиции! В этом тесте важен ваш первый, спонтанный ответ.'
	},
	payment: {
		one_time_payment: 'Единоразовая оплата за полный доступ',
		access_through_code: 'Получите доступ используя код активации',
		dont_have_access_code: 'Нет кода активации?',
		get_access_code: 'Получить код у менеджера'
	},
	report: {
		from: 'Результат от',
		retake_test: 'Пройти тест',
		empty_reports: 'У вас пока нет отчетов',
		did_not_pass_test:
			'Вы еще не прошли ни одного теста. Пройдите тест, чтобы увидеть результаты.',
		full_access_congrats: 'Поздравляем, вы разблокировали полный отчет!',
		send_to_email: 'Ваши результаты были отправлены на вашу почту',
		full_view: 'Смотреть полный отчет',
		full_report: 'Полный отчет',
		download_report: 'Скачать отчет'
	},
	errors: {
		unknown: 'Произошла неизвестная ошибка.'
	},
	assessment_plans: {
		assess_your_talents: 'Оцени свои таланты',
		learn_your_strength: 'Узнай свои сильные стороны и развивай их',
		increase_involvment: 'Больше вовлеченности в работу',
		increase_productivity: 'Выше продуктивность',
		increase_life_quality: 'Лучше качество жизни',
		buy_report: 'Купить отчет',
		buy_full_report: 'Купить полный отчет',
		six_times: '6 раз',
		three_times: '3 раза',
		most_popular: 'Самый популярный',
		safe_payment: 'Безопасная оплата',
		instant_access: 'Мгновенный доступ после оплаты'
	},
	demo_report: {
		congrats: 'поздравляем! Вы раскрыли свой уникальный потенциал.',
		sequence_of_strengths:
			'Эти таланты делают вас особенным и открывают уникальные возможности для развития.',
		your_strengths: 'Ваши сильные стороны',
		concentrate_on: 'Сосредоточьтесь на своих сильных сторонах',
		your_biggest_actives:
			'Ваши {{number}} главные сильные стороны — это ваши самые мощные активы. Наука показывает, что они — ваш самый большой шанс добиться успеха в профессиональной жизни и быть счастливым в личной жизни.',
		congrats_first_step:
			'Поздравляем, вы сделали первый шаг к раскрытию своего потенциала!',
		want_to_know_more: 'Хотите узнать больше? Полный отчет покажет: ',
		your_top5_talents: 'Ваши топ-5 талантов с подробным описанием.',
		brief_overview: 'Краткий обзор остальных 15 сильных сторон.',
		deep_understanding: 'Глубокое понимание своих сильных сторон.',
		open_full_report: 'Получить полный отчет',
		ai_breakdown: 'Разбор с помощью ИИ',
		course_access: 'Доступ к курсам'
	},
	unlock_demo_report: {
		discover_strength: 'Раскройте всю силу своих талантов!',
		your_top_one: `Ваш топ-1 талант — это только начало. В вас
								заложено гораздо больше потенциала, который
								может привести вас к новым вершинам. Узнайте о
								своих остальных ключевых талантах.`,
		extended_analysis:
			'Развернутый анализ всех ваших ТОП-5 талантов и их уникальное сочетание',
		recommendations:
			'Практические рекомендации по развитию каждого таланта',
		exact_steps: 'Конкретные шаги для применения талантов в работе и жизни',
		buy_report_by_key_talents: 'Купить отчет по ключевым талантам'
	},
	faq: {
		title: 'Часто задаваемые вопросы',
		how_will_it_help: 'Как приобретение полного отчета поможет мне?',
		will_it_help1: `Тест iTalent, который вы прошли, предоставляет ценные
						инсайты, но вы увидели только 5% того, что мы можем вам
						показать. Наш полный отчет содержит оставшиеся 95%
						инсайтов о ваших талантах и предлагает более глубокий
						анализ, чем то, что вы уже прочитали.`,
		will_it_help2: `Кроме того, наш тест демонстрирует, как можно улучшать
						свои сильные стороны и эффективно применять их на
						практике. Вы также поймете, в каких областях вы можете
						преуспевать больше всего.`,
		will_it_help3: `	Если вы действительно хотите понять себя и стать лучшей
						версией себя, изучение этих материалов необходимо.
						Рассматривайте их как вашу дорожную карту к более
						счастливой, успешной и разносторонней версии себя.`,
		may_i_believe: 'Могу ли я верить этим результатaм?',
		yes_you_can:
			'Абсолютно. Методология тестирования iTalent.kz основана на тех же исследованиях, которые используют исследовательские институты по определению личностных качеств. В сумме такие тесты прошли более 20 миллионов человек в мире.',
		how_much_will_it_cost: 'Сколько стоит тест и что в него входит?',
		first_plan: 'У нас есть два тарифа:',
		full_report: '1. Полный отчёт',
		report_comparison:
			'Для сравнения, мировые аналоги, такие как Gallup, стоят около 30000 тг.',
		what_will_you_get: 'Что вы получите:',
		you_will_get1: 'Развёрнутый анализ ваших ключевых талантов.',
		you_will_get2: 'Краткий обзор остальных сильных сторон.',
		you_will_get3: 'Полная структура талантов.',
		you_will_get4: 'Рекомендации по применению ваших талантов на практике.',
		second_plan: '2. Отчёт по топ-5 талантам',
		perfect_for:
			'Идеально для тех, кто хочет быстро узнать свои самые сильные стороны.',
		you_will_get21: 'Анализ ваших пяти ключевых талантов.',
		you_will_get22: 'Структурированная иерархия ваших талантов.',
		you_will_get23: 'Способы применения талантов.',

		for_whom: 'Кто может получить пользу от теста?',
		for_ambitious:
			'1. Целеустремленные люди: определяет качества, которые ускоряют достижение целей, и выявляет то, что может мешать.',
		for_lost:
			'2. Те, кто ищет себя: помогает найти свое предназначение, задав правильное направление развития.',
		for_extrasense:
			'3. Полагающиеся на интуицию: проверяет интуитивные предположения и показывает, на чем нужно сосредоточиться в первую очередь.',
		for_graduates:
			'4. Выпускники и студенты: тест помогает выбрать подходящую профессию, основываясь на сильных сторонах, и избежать ошибок.'
	},
	chat: {
		your_completed_reports: 'Ваши завершенные тесты',
		analysis_your_report:
			'Наш ИИ поможет вам разобрать результаты теста и раскрыть ваш потенциал в полной мере',
		enter_message: 'Введите сообщение...',
		ai_might_be_wrong:
			'AI может допускать ошибки. Рекомендуем проверять важную информацию.',
		sent: 'Отправлено',
		sending: 'Отправка...',
		error: 'Ошибка отправки',
		failed_to_send_message:
			'Не удалось отправить сообщение. Попробуйте еще раз.',
		discover_strength:
			'Раскройте свой потенциал с помощью искусственного интеллекта!',
		buy_full_report:
			'Для разбора с помощью AI вам нужно приобрести "Полный отчет"',
		start_analysis: 'Начать разбор с AI',
		clear_history: 'Очистить историю',
		history_cleared: 'История очищена'
	},
	ab_assessment_plans: {
		// Hero section
		heroTitle: 'Поздравляем! Ваш отчет готов!',
		heroSubtitle:
			'Узнайте, как раскрыть свой потенциал и использовать свои таланты для достижения успеха',

		// Preview Results
		previewTitle: 'Мы уже определили ваши ключевые таланты:',
		previewDescription:
			'Вы уже знаете 10% ваших талантов. Получите полный анализ для максимального использования ваших сильных сторон!',
		recommendedAreas: 'Рекомендуемые сферы применения ваших талантов',
		areasDescription:
			'На основе вашего уникального профиля, вам идеально подойдут следующие профессиональные области...',
		unlockInfo: 'Разблокируйте эту информацию в полном отчете',

		// Proof Grid
		accuracy: 'точность определения талантов',
		users: 'пользователей уже раскрыли свои таланты',
		productivity: 'рост продуктивности после применения',
		recommended: 'пользователей рекомендуют тест',

		// Testimonials
		testimonialsTitle: 'Что говорят наши пользователи',
		testimonial1:
			'Благодаря полному отчету iTalent я поняла свои сильные стороны и перестала тратить энергию на развитие неэффективных навыков. Это было как прозрение! Теперь я фокусируюсь на правильных направлениях.',
		author1: 'Александра, HR-специалист',
		testimonial2:
			'Мы использовали iTalent для нашей команды, чтобы понять, кто на каких позициях будет наиболее эффективен. После перераспределения ролей на основе талантов, производительность выросла на 12%.',
		author2: 'Бота, руководитель компании',
		testimonial3:
			'iTalent помог мне определиться с выбором второго образования. В отчете были конкретные рекомендации по сферам деятельности, что очень ценно, когда не знаешь, в каком направлении двигаться.',
		author3: 'Камила, студентка',

		// Plans
		plansTitle: 'Выберите свой отчет',
		functionsHeader: 'Функции',

		basicTitle: 'Отчет ТОП-5 талантов',
		standardTitle: 'Полный отчет + ИИ',
		premiumTitle: 'Полный отчет + ИИ + онлайн разбор с экспертом',

		mostPopular: 'Самый популярный',
		firstMeeting:
			'Базовый анализ для быстрого понимания ключевых сильных сторон',
		standardDescription:
			'Глубокий анализ потенциала с персональными рекомендациями от ИИ-ассистента',
		premiumDescription:
			'Премиум решение с индивидуальной консультацией эксперта для максимального результата',

		// Feature names
		keyTalents: 'Определение ключевых талантов',
		talentDescription: 'Описание талантов',
		structuralHierarchy: 'Структурная иерархия',
		applicationAreas: 'Сферы применения талантов',
		developmentRecommendations: 'Рекомендации по развитию',
		aiAnalysis: 'Анализ с использованием ИИ',
		careerRecommendations: 'Карьерные рекомендации',
		expertConsultation: 'Консультация с экспертом',
		instantAccess: 'Мгновенный доступ',

		// Feature values
		top3: 'Топ-3',
		top5: 'Топ-5',
		allTalents: 'Все таланты',
		allTalentsWithBreakdown: 'Все таланты с разбором',
		brief: 'Краткое',
		full: 'Полное',
		detailed: 'Развернутое',
		basic: 'Базовые',
		personalized: 'Персонализированные',
		thirtyMinutes: '60-90 минут',

		// Chips
		top3talents: 'Топ-3 таланта',
		top5talents: 'Топ-5 талантов',
		basicDescription: 'Базовое описание',
		fullAnalysis: 'Полный анализ',
		recommendations: 'Рекомендации',
		aiBreakdown: 'Разбор ИИ',
		consultation: 'Консультация',
		personalBreakdown: 'Персональный разбор',

		// Features list items
		feature_basic_1: 'ТОП-3 ваших талантов',
		feature_basic_2: 'Краткое описание каждого таланта',
		feature_basic_3: 'Базовая структурная иерархия',
		feature_basic_4: 'Общие рекомендации по развитию',
		feature_basic_5: 'Мгновенный доступ после оплаты',

		feature_standard_1: 'ТОП-5 ваших ключевых талантов',
		feature_standard_2: 'Полный анализ каждого таланта',
		feature_standard_3: 'Сферы применения ваших талантов',
		feature_standard_4: 'Конкретные рекомендации по развитию',
		feature_standard_5: 'Детальная структурная иерархия',
		feature_standard_6: 'Базовые карьерные рекомендации',
		feature_standard_7: 'Мгновенный доступ после оплаты',

		feature_premium_1: 'Анализ всех ваших талантов',
		feature_premium_2: 'ИИ-разбор ваших результатов',
		feature_premium_3: 'Развернутый анализ ключевых талантов',
		feature_premium_4: 'Обзор всех сильных сторон',
		feature_premium_5: 'Полная структура иерархии талантов',
		feature_premium_6: 'Детальные способы применения талантов',
		feature_premium_7: 'Персонализированные карьерные рекомендации',
		feature_premium_8: '60-90-минутный онлайн разбор с экспертом',
		feature_premium_9: 'Мгновенный доступ после оплаты',

		// Buttons
		selectButton: 'Выбрать',
		buyReportButton: 'Купить отчет',
		buyFullReportButton: 'Купить полный отчет ',
		buyFullReportButtonWithBreakdown: 'Купить полный отчет с разбором',
		securePayment: 'Безопасная оплата',

		// Guarantee
		guaranteeTitle: 'Гарантия удовлетворения 100%',
		guaranteeText:
			'Если отчет не оправдает ваших ожиданий, мы вернем вам деньги в течение 14 дней.',

		// Upgrade callout
		limitedOffer: 'Ограниченное предложение',
		upgradeTitle: 'Получите максимум от вашего теста',
		upgradeDescription:
			'Вы уже прошли тест и сделали первый шаг к самопознанию. Инвестируйте в себя и получите подробный отчет, который поможет вам раскрыть все ваши таланты!',
		getFullReportButton: 'Получить полный отчет',

		// FAQ
		faqTitle: 'Часто задаваемые вопросы',
		faq1_question: 'В чем разница между тарифами?',
		faq1_answer:
			'Базовый тариф дает представление о 3 ключевых талантах, Стандартный — о 5 талантах с рекомендациями по их применению, а Премиум включает полный анализ всех талантов, персонализированные рекомендации и консультацию эксперта.',
		faq2_question: 'Насколько точны результаты теста?',
		faq2_answer:
			'iTalent разработан на основе современных психометрических методик и валидирован на выборке более 25 000 человек. Тест демонстрирует высокую точность (98%) при определении талантов и сильных сторон личности.',
		faq3_question: 'Как быстро я получу доступ к отчету?',
		faq3_answer:
			'Доступ к вашему отчету предоставляется мгновенно после успешной оплаты. Вы сможете просмотреть его онлайн или скачать в PDF-формате.',
		faq4_question: 'Что делать с результатами теста?',
		faq4_answer:
			'В зависимости от выбранного тарифа, вы получите различные рекомендации по применению ваших талантов. Вы можете использовать результаты для выбора карьерного пути, повышения эффективности в текущей работе, саморазвития или профессиональной переориентации.',
		faq5_question: 'Почему стоит купить полный отчет?',
		faq5_answer:
			'Базовый отчет дает только общее представление о ваших ключевых талантах, в то время как полный отчет предоставляет детальный анализ всех ваших сильных сторон, конкретные рекомендации по их применению и персонализированные карьерные советы. Инвестиция в полный отчет окупается повышением профессиональной эффективности и удовлетворенности от работы.'
	},
	survey: {
		discount: 'СКИДКА {{percentage}}%',
		take_survey_get_discount: 'Пройдите опрос и получите скидку!',
		answer_questions_get_discount:
			'Ответьте на несколько вопросов о ваших талантах и получите промокод на скидку {{percentage}}% на любой тариф',
		take_short_survey: 'Пройти короткий опрос',
		your_discount_code: 'Ваш промокод был активирован!',
		use_code_at_checkout:
			'Ваш промокод уже применен. Вам нужно просто оплатить и получить доступ к отчету.',
		short_survey_about_talents: 'Короткий опрос о ваших талантах',
		question_1: 'Что для вас важнее всего в развитии талантов?',
		question_2: 'Как вы узнали о нашем сервисе?',
		question_3: 'Какие отчеты вас интересуют больше всего?',
		select_answer: 'Выберите ответ',
		career_growth: 'Карьерный рост',
		personal_development: 'Личное развитие',
		financial_success: 'Финансовый успех',
		self_realization: 'Самореализация',
		search_engines: 'Поисковые системы',
		social_media: 'Социальные сети',
		from_friends: 'От друзей/знакомых',
		advertising: 'Реклама',
		top_3_talents: 'Топ 3 таланта',
		top_5_talents: 'Топ 5 талантов',
		full_report: 'Полный отчет',
		thanks_for_survey: 'Спасибо за прохождение опроса!',
		use_code_for_discount:
			'Используйте этот код при оформлении заказа, чтобы получить скидку {{percentage}}%',
		submit_get_discount: 'Отправить и получить скидку',
		please_answer_all: 'Пожалуйста, ответьте на все вопросы',
		enter_your_answer: 'Введите ваш ответ',
		error_submitting:
			'Ошибка при отправке опроса. Пожалуйста, попробуйте еще раз.'
	},
	courses: {
		courses: 'Курсы',
		courses_pass: 'Пройти курсы'
	}
};
